<template>
    <div>
        <checbox-expandable v-if="checkboxData.type === 'expandable'" :checkboxData="checkboxData" @accepted="accept()" @canceled="cancel()" :externalExpandedState="externalState" />
        <checbox-external v-if="checkboxData.type === 'raw-label'" :checkboxData="checkboxData" @accepted="accept()" @canceled="cancel()" />
        <checbox-iframe v-if="checkboxData.type === 'iframe'" :checkboxData="checkboxData" @accepted="accept()" @canceled="cancel()" />
    </div>
</template>

<script>
import CheckboxExpandable from './checkboxes/checkbox-expandable.vue';
import CheckboxRawLabel from './checkboxes/checkbox-raw-label.vue';
import CheckboxIframe from './checkboxes/checkbox-iframe.vue';

export default {
    components: {
        'checbox-expandable': CheckboxExpandable,
        'checbox-external': CheckboxRawLabel,
        'checbox-iframe': CheckboxIframe,
    },
    props:  {
        checkboxData: {
            type: Object,
            default() {
                return { type: 'raw-label' }
            }         
        },
        externalState: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        checked: false,
        entityConfig: {},
    }),
    mounted() {
        this.entityConfig = this.$store.state.entityConfig.config;        
    },
    updated() {
        if (this.checkboxData.type == 'hidden') {
            this.accept();
        }
    },
    methods: {
        accept() {
            this.$emit("accepted");
        },
        cancel() {
            this.$emit("canceled");
        },
    },
}
</script>